import { LogoutOutlined as LogoutOutlinedIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { Footer } from '../../../design/components/Footer';
import { CopyrightTenant } from '../../CopyrightTenant';
import { LanguageSelect } from '../../common/LanguageSelect';

const FooterLogoutButton: FunctionComponent = () => {
    const { actions, applicationState, translate } = useContext(ApplicationContext);

    if (applicationState.userIsLoggedIn === false) {
        return null;
    }

    const handleLogout = (): void => {
        actions.logout();
    };

    return (
        <Button startIcon={<LogoutOutlinedIcon />} sx={{ color: 'text.secondary' }} onClick={handleLogout}>
            <Typography color="text.secondary" variant="body1">
                {translate('common.logout')}
            </Typography>
        </Button>
    );
};

export const OnboardingFooter: FunctionComponent = () => {
    const { applicationState } = useContext(ApplicationContext);

    return (
        <Footer>
            <LanguageSelect isUnderlineDisabled={true} />
            <CopyrightTenant />
            {applicationState.userIsLoggedIn && <FooterLogoutButton />}
        </Footer>
    );
};
